import React, {useEffect} from 'react'
import {Provider} from 'react-redux'
import {BrowserRouter as Router, Route, Switch, useLocation} from 'react-router-dom'
import {QueryParamProvider} from 'use-query-params'

import createStore from 'admin/store'

import Organisation from 'admin/components/Organisation'

import Dashboard from 'admin/components/Dashboard'

import Account from 'admin/components/Account'

import GroupsLayout from 'admin/components/layouts/GroupsLayout'
import AccountsLayout from 'admin/components/layouts/AccountsLayout'

import TextMessages from 'admin/components/TextMessages'

import ListUsers from 'admin/components/Users'

import Invoice from 'admin/components/Invoice'
import NewInvoice from 'admin/components/NewInvoice'
import ListInvoices from 'admin/components/Invoices'
import ListRepeatingInvoices from 'admin/components/RepeatingInvoices'
import ListPaymentRules from 'admin/components/PaymentRules'
import PaymentsLayout from 'admin/components/layouts/PaymentsLayout'

import RepeatingInvoice from 'admin/components/RepeatingInvoice'
import NewRepeatingInvoice from './admin/components/NewRepeatingInvoice'
import Map from './admin/components/Map'

import createApolloClient, {ApolloProvider} from 'admin/lib/apollo'

import ModalManager from './admin/components/ModalManager'
import ServicesLayout from './admin/components/layouts/ServicesLayout'
import AppLayout from './admin/components/AppLayout'

const renderWithLayout = Component => props => (
  <AppLayout>
    <Component {...props} />
  </AppLayout>
)

const ScrollToTop = () => {
  const {pathname} = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ({organisationId, ...props}) => (
  <ApolloProvider client={createApolloClient({organisationId})}>
    <Provider store={createStore(props)}>
      <Router>
        <QueryParamProvider ReactRouterRoute={Route}>
          <ScrollToTop />
          <Route path='/orgs/:organisationID(\d+)' component={ModalManager} />
          <Route exact path='/orgs/:organisationID(\d+)' render={renderWithLayout(Dashboard)} />
          <Route exact path='/orgs/:organisationID(\d+)/map' render={renderWithLayout(Map)} />

          <Switch>
            <Route path='/orgs/:organisationID(\d+)/edit' render={renderWithLayout(Organisation)} />
            <Route
              path='/orgs/:organisationID(\d+)/repeating_invoices/new'
              render={renderWithLayout(NewRepeatingInvoice)}
            />
            <Route
              path='/orgs/:organisationID(\d+)/repeating_invoices/:repeatingInvoiceID(\d+)'
              render={renderWithLayout(RepeatingInvoice)}
            />
            <Route
              path='/orgs/:organisationID(\d+)/repeating_invoices'
              render={renderWithLayout(ListRepeatingInvoices)}
            />
            <Route path='/orgs/:organisationID(\d+)/invoices/new' render={renderWithLayout(NewInvoice)} />
            <Route path='/orgs/:organisationID(\d+)/invoices/:invoiceID(\d+)' render={renderWithLayout(Invoice)} />
            <Route path='/orgs/:organisationID(\d+)/invoices' render={renderWithLayout(ListInvoices)} />
            <Route path='/orgs/:organisationID(\d+)/payments' component={renderWithLayout(PaymentsLayout)} />
            <Route path='/orgs/:organisationID(\d+)/payment_rules' render={renderWithLayout(ListPaymentRules)} />
            <Route path='/orgs/:organisationID(\d+)/groups' render={renderWithLayout(GroupsLayout)} />
            <Route path='/orgs/:organisationID(\d+)/text_messages' render={renderWithLayout(TextMessages)} />
            <Route path='/orgs/:organisationID(\d+)/accounts/:accountID(\d+)' render={renderWithLayout(Account)} />
            <Route path='/orgs/:organisationID(\d+)/accounts' render={renderWithLayout(AccountsLayout)} />
            <Route path='/orgs/:organisationID(\d+)/services' render={renderWithLayout(ServicesLayout)} />
            <Route path='/orgs/:organisationID(\d+)/users' render={renderWithLayout(ListUsers)} />
          </Switch>
        </QueryParamProvider>
      </Router>
    </Provider>
  </ApolloProvider>
)
